import React from 'react';
import clsx from 'clsx';

interface ErrorMessageProps {
  message: string;
  className?: string;
  onDismiss?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className,
  onDismiss,
}) => {
  return (
    <div className={clsx('error-message', className)}>
      <span className="error-message-text">{message}</span>
      {onDismiss && (
        <button className="error-message-dismiss" onClick={onDismiss}>
          ×
        </button>
      )}
    </div>
  );
};

